export enum ViewType {
  Supplier = 'supplier',
  Purchaser = 'purchaser',
  Utility = 'utility',
}
